import axios from "axios";
import { mapReportTypesDict } from "../mapper";

export async function getReportTypes() {
    return axios
        .get(`${process.env.API_URL}/reports/dictionary`)
        .then(response =>
            mapReportTypesDict(response.data)
        );
}
